export default __webpack_public_path__ + "static/ClydeComets-99f03aa72e2d7b89398eb67654620929.jpg";